import { logLoginTimeAsync } from '../server/server'

export const logLoginTime = async (data, write = true) => {
    const resp = await logLoginTimeAsync(data)
    if (resp.status !== 200) {
        let restLogins = JSON.parse(localStorage.getItem('loginsLogs') || '[]')
        restLogins.push(data)
        if (write) localStorage.setItem('loginsLogs', JSON.stringify(restLogins))
        return false
    }
    return true
}
